// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./toolbar/styles.scss
// module id = 1021
// module chunks = 0